import bundleFeature from '../../utils/bundleFeature'

import {
  WebinarAudienceMobileSidebarComponent,
  WebinarAudienceSidebarComponent,
} from './components/WebinarAudienceSidebarComponent'
import sagas from './sagas'
import actions from './actions'
import reducer from './reducer'

export default bundleFeature({
  Component: WebinarAudienceSidebarComponent,
  actions,
  sagas,
  reducer,
})

const WebinarAudienceMobileSidebarFeature = bundleFeature({
  Component: WebinarAudienceMobileSidebarComponent,
  actions,
  sagas,
  reducer,
})

export { WebinarAudienceMobileSidebarFeature }
